import { Navigate, Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const PendingApproval = () => (
  <div data-testid="pending-approval" className="grid-bg min-h-[85vh] flex items-center justify-center px-4 py-16">
    <div className="brutal-card brutal-shadow max-w-md text-center" style={{ borderColor: "#FFCE00" }}>
      <Clock className="mx-auto text-[#FFCE00]" size={56} />
      <div className="font-bebas text-5xl mt-4 tracking-tighter">PIX EM ANÁLISE</div>
      <p className="mt-3 text-white/70 font-manrope">
        Recebemos tua confirmação. Assim que a gente conferir o pagamento, teu acesso completo é liberado por 30 dias e tu recebe um aviso por email.
      </p>
      <p className="mt-3 text-white/50 font-manrope text-sm">Enquanto isso, a 1ª aula de cada curso tá liberada.</p>
      <Link to="/cursos" data-testid="pending-to-courses" className="brutal-btn mt-8 w-full">Ver aula grátis</Link>
      <Link to="/pagar/pix" data-testid="pending-to-pix" className="block mt-4 text-white/50 font-manrope text-sm underline">Ver dados do Pix de novo</Link>
    </div>
  </div>
);

export const RequireSub = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-white/40">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.is_admin || user.subscription_active) return children;
  if (user.subscription_status === "pix_pending_review") return <PendingApproval />;
  return <Navigate to="/pagar/pix" replace />;
};
